import { Address } from '@synergy/models';

import { AccountApi } from '../api/account-api';

/** The one candidate there is, or nothing when there is none or a choice. */
export const onlyOne = <T>(candidates?: T[]): T | undefined => (1 === candidates?.length ? candidates[0] : undefined);

/**
 * The invoice addresses an account can be billed at.
 *
 * Read the way the field's own dropdown reads them, including the addresses of
 * the parent organisation: a branch without an invoice address of its own is
 * billed at its parent's (#2250, R-146).
 */
export const fetchInvoiceAddresses = async (api: AccountApi, accountId: number): Promise<Address[]> => {
    const addresses = await api.getAddresses(accountId, undefined, true);

    return addresses.success ? addresses.result.filter(address => address.isInvoiceAddress) : [];
};
